export default "__VITE_ASSET__cdec92bd__"